import React from 'react';
export function OfferSection() {
  return <div className="max-w-3xl mx-auto px-4 py-8" data-id="element-93">
      <div className="bg-gray-100 p-8 rounded-lg text-center" data-id="element-94">
        <h2 className="text-xl font-bold mb-4" data-id="element-95">
          You're Still In The Game—Don't Let Your Body Bench You
        </h2>
        <div className="bg-yellow-100 p-4 rounded-lg mb-6 font-bold text-lg" data-id="element-96">
          LIMITED TIME: Buy 2 Bottles, Get 1 Free
        </div>
        <p className="mb-6" data-id="element-97">
          You're still working. Still leading. Still showing up every day.
        </p>
        <p className="mb-6" data-id="element-98">
          You don't have time to feel foggy, exhausted, or like you're slipping
          while younger people watch.
        </p>
        <p className="mb-6" data-id="element-99">
          If stress is spiking your glucose and those crashes are costing you
          your edge—you owe it to yourself to try the one approach designed
          specifically for that problem.
        </p>
        <p className="mb-6" data-id="element-100">
          The men who wait are the ones who wake up six months from now still
          struggling. Still foggy. Still watching opportunities slip away
          because they couldn't think clearly when it mattered.
        </p>
        <p className="mb-6" data-id="element-101">
          You didn't build your career by waiting. Don't start now.
        </p>
        <p className="mb-6" data-id="element-102">
          <span className="font-bold" data-id="element-103">90-Day Money-Back Guarantee:</span> Try
          Glucora for a full 90 days. If you don't feel sharper, steadier, and
          more like yourself, contact us for a full refund. No questions asked.
        </p>
        <div className="flex justify-center mb-6" data-id="element-104">
          <a href="https://seravaco.shop/products/glucora%E2%84%A2-metaboshield%E2%84%A2?variant=47313966498019" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition-colors duration-300" data-id="element-105">
            CHECK AVAILABILITY NOW →
          </a>
        </div>
      </div>
      <div className="my-8" data-id="element-106">
        
        
      </div>
      <div className="mt-10 mb-6" data-id="element-107">
        <p className="mb-4" data-id="element-108">
          I'm not a doctor. I'm just a guy who spent two years feeling like I
          was losing myself—and found a solution that finally made sense.
        </p>
        <p className="mb-4" data-id="element-109">
          If you're tired of the 3 PM wall, the brain fog when people need you
          sharp, and the fear this is just "aging"—there's another path.
        </p>
        <p className="mb-4" data-id="element-110">You deserve to feel capable again.</p>
        <p className="mb-6" data-id="element-111">— Michael Patterson</p>
      </div>
      <div className="border-t border-gray-300 pt-6 text-xs text-gray-600" data-id="element-112"></div>
      <div className="my-8" data-id="element-113"></div>
    </div>;
}